export default __webpack_public_path__ + "static/article-digital-shopping-options-allow-you-more-freedom-e5c650ceb6c0529e49b6b1520ffa0250.jpg";